module.exports = __webpack_public_path__ + "img/w3_sort_bars_asc_dark.72e2dba9.png";